import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// import ShowcaseMain from '../../../layouts/showcaseLayouts/ShowcaseMain/ShowcaseMain';
// import classes from './MainPage.module.css';
import './mainPage.scss';

const MainPage: React.FC = () => {
    useEffect(() => {
        const savedScrollPosition = sessionStorage.getItem('scrollPosition');
        if (savedScrollPosition) {
            window.scrollTo(0, parseInt(savedScrollPosition, 10));
        }
        return () => {
            sessionStorage.setItem('scrollPosition', window.scrollY.toString());
        };
    }, []);

    return (
        // <div className={classes.mainPage}>
        // <ShowcaseMain>
        <main className="main">
            <Outlet />
        </main>
        // </ShowcaseMain>
        // </div>
    );
};

export default MainPage;
